import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import { Form, Button, Table, InputGroup, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function UserListPage() {
    const [user, setUser] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setdata] = useState([]);
       
    useEffect(() => {
        fetchUser();        
    }, []);

    const fetchUser = async () => {
        try {
            debugger;
            const response = await adminInstance.get("user/get");
            setUser(response.data || []);
            setdata(response.data || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const navigate = useNavigate();    

    const handleEdit = (userId) => {
        navigate(`/manageuser/${userId}`);
    }

    const handleNew = () => {
        navigate('/manageuser');
    }
    
    const filteredData = data
    .filter(spare =>
      spare.UserName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <h4>
                            User Manager
                        </h4>
                    </div>
                    <div className="card-body aon-card-body">  
                        <Button variant="primary" type="submit" onClick={() => handleNew()}>
                                            Create New
                                            </Button>                      
                        {
                            <div className="sf-bs-data-table">
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-bordered example-dt-table aon-booking-table responsive  table-hover" style={{ width: '100%'}}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Employee Name</th>
                                                <th>User Name</th>
                                                <th>Is Admin</th>
                                                <th style={{ width: '100px' }}>Role</th>
                                                <th style={{ width: '100px' }}>State</th>
                                                <th>Status</th>
                                                <th>Action</th>                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr >
                                            <td colSpan={8}>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                                placeholder="Search user..."
                                                value={searchTerm}
                                                onChange={e => setSearchTerm(e.target.value)}
                                            />
                                            </InputGroup>
                                            </td>
                                        </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}
                                                            onClick={() => handleEdit(emp.UserId)}
                                                            style={{ cursor: 'pointer' }}>
                                                            <td>{emp.UserId}</td>
                                                            <td>{emp.EmpName}</td>
                                                            <td>{emp.UserName}</td>
                                                            <td>{emp.IsAdmin ? <Badge bg="success">Admin</Badge> : <Badge bg="danger">User</Badge>}</td>
                                                            <td>{emp.AllowSection}</td>
                                                            <td>{emp.UserState}</td>
                                                            <td>{emp.IsActive ? <Badge bg="success">Active</Badge> : <Badge bg="danger">Inactive</Badge>}</td>
                                                            <td>
                                                                <button className="admin-button wid-200" onClick={() => handleEdit(emp.UserId)} style={{marginRight:20}}>Edit</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                          }                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default UserListPage;
